/** Type guard compartido por los parsers del traspaso P2P (JSON no confiable). */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}
